import { useState } from "react";
import api from "../utils/axios";

export default function Signup() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    designation: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  async function handleSignup(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post("/auth/signup", form);

      if (res.data.ok) {
        alert("Signup successful! Please login now.");
        window.location.href = "/login";
      }
    } catch (err) {
      alert(err.response?.data?.error || "Signup failed");
    }

    setLoading(false);
  }

  return (
    <div className="flex h-screen justify-center items-center">
      <form
        className="p-6 shadow rounded bg-white w-96"
        onSubmit={handleSignup}
      >
        <h2 className="mb-4 text-xl font-bold text-center">Create Account</h2>

        <input
          className="border p-2 w-full mb-3"
          placeholder="Full Name"
          name="name"
          onChange={handleChange}
        />

        <input
          className="border p-2 w-full mb-3"
          placeholder="Email"
          type="email"
          name="email"
          onChange={handleChange}
        />

        <input
          className="border p-2 w-full mb-3"
          placeholder="Password"
          type="password"
          name="password"
          onChange={handleChange}
        />

        <select
          name="designation"
          className="border p-2 w-full mb-4"
          onChange={handleChange}
        >
          <option value="">Select Designation</option>
          <option value="CEO">CEO</option>
          <option value="Admin">Admin</option>
          <option value="CSM">CSM</option>
          <option value="Owner">Owner</option>
          <option value="Manager">Manager</option>
        </select>

        <button
          className="w-full bg-blue-600 text-white py-2 rounded"
          disabled={loading}
        >
          {loading ? "Creating..." : "Signup"}
        </button>

        <p className="mt-3 text-center text-sm">
          Already have an account?{" "}
          <a href="/login" className="text-blue-500 underline">
            Login
          </a>
        </p>
      </form>
    </div>
  );
}
